import { ConstructPoolPortalOwnersHeaders } from "modules/PoolPortal/helpers/headers"
import {
  AdminSettingsEnum,
  PoolPortalOwner,
  PoolPortalOwners,
} from "modules/PoolPortal/helpers/types"
import { useOwners } from "modules/PoolPortal/hooks/useOwnersAPI"
import { FormatEnumToString, GetEntryPageState } from "modules/PoolPortal/utils"
import { useEffect, useState } from "react"
import { Button, Modal, Offcanvas } from "react-bootstrap"
import { SettingsEntryHOC } from "../SettingsHOC"
import { SettingsTable } from "../SettingsTable"

export const OwnersAdminMain = () => {
  const { owners, isLoading, deleteOwner } = useOwners()

  const [ownersData, setOwnersData] = useState(
    owners ?? ([] as PoolPortalOwners)
  )
  const [showEntryBlade, setShowEntryBlade] = useState(false)
  const [showDelete, setShowDelete] = useState(false)
  const [currentOwner, setCurrentOwner] = useState({} as PoolPortalOwner)

  useEffect(() => {
    if (owners) {
      setOwnersData([...owners])
    }
  }, [isLoading, owners])

  const handleEditBladeClose = () => {
    setShowEntryBlade(false)
  }
  const handleEditBladeShow = () => {
    setShowEntryBlade(true)
  }

  const newOwnersHandler = () => {
    setShowEntryBlade(true)
    setCurrentOwner({} as PoolPortalOwner)
  }

  const editOwnerHandler = (id: string) => {
    const data = ownersData as PoolPortalOwners
    if (data) {
      var foundIndex = data?.findIndex((x: PoolPortalOwner) => x.id === id)
      setCurrentOwner(data[foundIndex])
      handleEditBladeShow()
    }
  }

  const deleteOwnerHandler = (id: string) => {
    // show the pop here and set the currentOwner for deletion
    const data = ownersData as PoolPortalOwners
    if (data) {
      var foundIndex = data?.findIndex((x: PoolPortalOwner) => x.id === id)
      setCurrentOwner(data[foundIndex])
      setShowDelete(true)
    }
  }

  const modalDeleteHandler = async () => {
    //  actual deletion
    await deleteOwner(currentOwner.id)
    setShowDelete(false)
  }

  return (
    <>
      <Modal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        style={{ zIndex: 5060 }}
        backdropClassName="SettingsDeleteConfirmationBackDrop"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Owner</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the "{currentOwner.name}" owner?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={modalDeleteHandler}>
            Delete
          </Button>
          <Button variant="secondary" onClick={() => setShowDelete(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Offcanvas
        className="PoolPortal_SettingsEditOffcanvas"
        show={showEntryBlade}
        onHide={handleEditBladeClose}
        placement="end"
        backdrop="static"
        scroll={false}
        style={{ zIndex: 4060 }}
        backdropClassName="SettingsEditOffCanvassBackDrop"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            Settings - {GetEntryPageState(currentOwner)}{" "}
            {FormatEnumToString(AdminSettingsEnum.OWNERS)}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <SettingsEntryHOC
            type={AdminSettingsEnum.OWNERS}
            data={currentOwner}
            setShowEntryBlade={setShowEntryBlade}
          />
        </Offcanvas.Body>
      </Offcanvas>
      <SettingsTable
        body={ownersData!}
        headers={ConstructPoolPortalOwnersHeaders(
          editOwnerHandler,
          deleteOwnerHandler
        )}
        newHandler={newOwnersHandler}
      />
    </>
  )
}
